import { render, staticRenderFns } from "./CardDescription.vue?vue&type=template&id=4518e198"
import script from "./CardDescription.vue?vue&type=script&lang=js"
export * from "./CardDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports